import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import ConnectButton from './ConnectButton'
import Text from '../Text'
import {inject, observer} from "mobx-react";
import {authService} from "../../../services";

const propTypes = {
    classes: PropTypes.object.isRequired
};

const bannerBackgrounds = {
    small: 'https://cdn.streamelements.com/assets/chat-stats-assets/banner/banner-small.png',
    medium: 'https://cdn.streamelements.com/assets/chat-stats-assets/banner/banner-mid.png',
    large: 'https://cdn.streamelements.com/assets/chat-stats-assets/banner/banner-large.png'
};

@inject('auth') @observer
class ConnectBanner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isHovered: false
        };
        this.toggleHovered = this.toggleHovered.bind(this);
    }

    toggleHovered() {
        this.setState((prevState) => {
            return {
                isHovered: !prevState.isHovered
            }
        });
    }

    render() {
        const {classes, auth} = this.props;
        const {isHovered} = this.state;
        const connectionPath = auth.isUserLoggedIn ? 'dashboard' : 'twitch';
        const connectionUrl = authService.getConnectionUrl(connectionPath);
        //don't show a button unlessthe user is either logged in or out
        const shouldShowButton = !(auth.connectionState === authService.loginStatesEnum.PENDING);

        return (
            <a className={classes.bannerAnchor} href={connectionUrl}>
                <div onMouseEnter={this.toggleHovered} onMouseLeave={this.toggleHovered} className={classes.banner}>
                    <div className={classes.bannerContent}>
                        <Text type='bannerTitle'>
                            SUPER-CHARGE <br className={classes.headerBreaker}/>YOUR STREAM
                        </Text>
                        <Text type='bannerDescription'>
                            Chat Bot <span className={classes.ticks}>//</span> Overlays <span
                            className={classes.ticks}>//</span> Loyalty System <span
                            className={classes.ticks}>//</span> Tipping and Alerts
                        </Text>
                        {shouldShowButton &&
                        <ConnectButton forceHoveredEffect={isHovered} service={connectionPath}/>
                        }
                    </div>
                </div>
            </a>
        )
    }
}

const styles = theme => ({
    bannerContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        color: 'white',
        textAlign: 'center'
    },
    headerBreaker: {
        display: 'none',
        [theme.devices.small]: {
            display: 'inherit'
        }
    },
    ticks: {
        color: '#f9af15'
    },
    banner: {
        backgroundImage: `url(${bannerBackgrounds.large})`,
        padding: '30px 10px',
        backgroundSize: 'cover',
        backgroundPositionY: 'bottom',
        backgroundPositionX: 'left',
        backgroundRepeat: 'no-repeat',
        borderRadius: '8px',
        overflow: 'hidden',
        marginBottom: '10px',
        cursor: 'pointer',
        width: '100%',
        [theme.devices.small]: {
            backgroundImage: `url(${bannerBackgrounds.small})`,
        }
    },
    bannerAnchor: {
        textDecoration: 'none'
    }
});

ConnectBanner.propTypes = propTypes;

export default injectSheet(styles)(ConnectBanner);



// WEBPACK FOOTER //
// ./src/app/components/banner/ConnectBanner.js